<template>
    <svg
        :height='height'
        :width='width'
        :fill='fill'
        xmlns:x="http://ns.adobe.com/Extensibility/1.0/"
        xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/"
        xmlns:graph="http://ns.adobe.com/Graphs/1.0/"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        x="0px" y="0px"
        viewBox="0 0 100 100"
        style="enable-background:new 0 0 100 100;"
        xml:space="preserve">
        <g>
            <g i:extraneous="self">
                <g>
                    <path d="M83,61.8L83,61.8c-2.8-3.4-4.3-7.7-4.3-12.1V39.6c0-14.6-11-26.7-25.1-28.5v-5c0-2-1.6-3.6-3.6-3.6s-3.6,1.6-3.6,3.6v5     C32.3,12.9,21.3,25,21.3,39.6v10.1c0,4.4-1.5,8.7-4.3,12.1l-4.4,5.4c-2.3,2.8-2.8,6.7-1.2,10c1.6,3.3,4.8,5.4,8.5,5.4h13.8     c0.8,8.4,7.8,14.9,16.4,14.9c8.6,0,15.6-6.6,16.4-14.9h13.8c3.7,0,6.9-2.1,8.5-5.4c1.6-3.3,1.1-7.1-1.2-10L83,61.8z M50,90.3     c-4.6,0-8.4-3.4-9.1-7.8h18.2C58.4,86.9,54.6,90.3,50,90.3z M82.2,74.1c-0.2,0.4-0.7,1.3-2,1.3H19.8c-1.3,0-1.8-0.9-2-1.3     s-0.5-1.4,0.3-2.4l4.4-5.4c3.8-4.7,5.9-10.6,5.9-16.7V39.6C28.5,27.7,38.1,18,50,18c11.9,0,21.5,9.7,21.5,21.5v10.1     c0,6.1,2.1,12,5.9,16.7l4.4,5.4C82.7,72.7,82.4,73.7,82.2,74.1z">
                    </path>
                    <path d="M14.5,29.7c2.3-8.3,7.5-15.5,14.6-20.5c1.6-1.1,2-3.4,0.9-5c-1.1-1.6-3.4-2-5-0.9C16.6,9.2,10.4,17.9,7.6,27.8     c-0.5,1.9,0.6,3.9,2.5,4.4c0.3,0.1,0.6,0.1,1,0.1C12.6,32.4,14.1,31.3,14.5,29.7z">
                    </path>
                    <path d="M92.4,27.8C89.6,17.9,83.4,9.2,75,3.3c-1.6-1.1-3.9-0.7-5,0.9c-1.1,1.6-0.7,3.9,0.9,5c7.1,4.9,12.3,12.2,14.6,20.5     c0.4,1.6,1.9,2.6,3.5,2.6c0.3,0,0.6,0,1-0.1C91.8,31.7,92.9,29.7,92.4,27.8z">
                    </path>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'NotificationBellIcon',
  props: {
    width: {
      type: Number,
      default: 30,
      required: false,
    },
    height: {
      type: Number,
      default: 30,
      required: false,
    },
    fill: {
      type: String,
      default: 'white',
      required: false,
    },
  },
};
</script>

<style lang="css" scoped></style>
